import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/#how-it-works", label: "How it works", id: "nav-how-link", hash: true },
  { to: "/#features", label: "Features", id: "nav-features-link", hash: true },
  { to: "/#pricing", label: "Pricing", id: "nav-pricing-link", hash: true },
  { to: "/privacy", label: "Privacy", id: "nav-privacy-link" },
  { to: "/contact", label: "Contact", id: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="fixed inset-x-0 top-0 z-50 border-b border-terradark/30 bg-terra/95 backdrop-blur-md"
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          data-testid="nav-brand-link"
          className="flex items-center gap-2.5"
          onClick={() => setOpen(false)}
        >
          <img
            src="/assets/icon-transparent.png"
            alt="Moove icon"
            className="h-8 w-auto"
          />
          <span className="font-poppins text-lg font-semibold tracking-tight text-cream">
            Moove
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) =>
            l.hash ? (
              <Link
                key={l.id}
                to={l.to}
                data-testid={l.id}
                className="text-sm font-medium text-cream/80 transition-colors duration-300 hover:text-cream"
              >
                {l.label}
              </Link>
            ) : (
              <NavLink
                key={l.id}
                to={l.to}
                data-testid={l.id}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors duration-300 ${
                    isActive ? "text-cream underline underline-offset-4" : "text-cream/80 hover:text-cream"
                  }`
                }
              >
                {l.label}
              </NavLink>
            )
          )}
          <span
            data-testid="nav-download-button"
            className="cursor-default rounded-full bg-cream px-5 py-2 text-sm font-semibold text-terra"
          >
            Coming soon
          </span>
        </div>

        <button
          data-testid="nav-menu-toggle"
          className="text-cream md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-terradark/30 bg-terra px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <Link
                key={l.id}
                to={l.to}
                data-testid={`${l.id}-mobile`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-cream"
              >
                {l.label}
              </Link>
            ))}
            <span className="w-fit rounded-full bg-cream px-5 py-2 text-sm font-semibold text-terra">
              Coming soon
            </span>
          </div>
        </div>
      )}
    </header>
  );
};
